import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import setSort from '../actions/setSort';
import { sortOptions } from '../utils/sorting';

export const Sort = () => {
	const { sortType } = useSelector((state) => state.sort);
	const dispatch = useDispatch();
	const labels = useLabels();

	const handleChange = (e) => {
		dispatch(setSort(e.target.value));
	};

	return (
		<form className="sort pt-0">
			<label
				htmlFor="sort-select"
				className="sort-label d-flex flex-column font-weight-normal"
			>
				{labels.get('SORT_BY')}
				<select
					onChange={handleChange}
					value={sortType}
					aria-label="Select Sort"
					id="sort-select"
					className="form-control pr-9"
				>
					{Array.from(sortOptions, ([value, displayName]) => (
						<option value={value} key={value}>
							{labels.get(displayName)}
						</option>
					))}
				</select>
			</label>
		</form>
	);
};
